import moment from 'moment';

/**
   * Orca validation, in order to know if the policy is basic,
   * based on its incident limit.
   * @param {*} incidentLimit incident limit of the Orca policy.
   */
const isBasicOrcaPolicy = (
  incidentLimit,
) => parseInt(incidentLimit, 10) === 500;

function formatDate(date) {
  return !date ? '-' : moment(date.split('T')[0]).format('MM/DD/YYYY');
}

export {
  isBasicOrcaPolicy,
  formatDate,
};
